import React from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

const Avatar = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
}));

const BottomIconAvatar = () => {
  const user0 = require("assets/Profile/buku_default_avatar.png");
  const tip = require("assets/tip-icon.png");
  return (
    <Avatar>
      <img
        src={user0}
        alt={"img"}
        style={{
          width: "47px",
          height: "47px",
          borderStyle: "solid",
          borderRadius: "50%",
          borderWidth: "2px",
          borderColor: "#ffffff",
        }}
      />
      <img
        src={tip}
        alt={"img"}
        style={{
          width: "19px",
          height: "19px",
          position: "relative",
          top: "-10px",
          left: "13px",
        }}
      />
    </Avatar>
  );
};

export default BottomIconAvatar;
